<div class="row">
    <div class="submenu">
        <div class="{{ menu.class }}" *ngFor="let menu of subMenus">
            <h5 *ngIf="menu.active" class="text-light">{{ menu.label }}</h5>
            <a *ngIf="menu.child" [routerLink]="[menu.router]">{{ menu.label }}</a>
        </div>
    </div>
</div>
